import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const CalendarIcon = (props: SvgProps) => (
  <Svg
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <Path
      fill={props.fill}
      d="M12.403 14.949c-.48 0-.888-.168-1.222-.502a1.664 1.664 0 0 1-.502-1.223c0-.48.167-.888.502-1.222a1.664 1.664 0 0 1 1.222-.502c.48 0 .888.167 1.223.502.334.334.502.742.502 1.222s-.168.888-.502 1.223a1.664 1.664 0 0 1-1.223.502Zm-7.676 2.423c-.358 0-.66-.124-.908-.371a1.234 1.234 0 0 1-.37-.908V5.547c0-.357.123-.66.37-.907s.551-.37.911-.37H6.27V2.41h.833v1.86h5.86V2.41h.768v1.86h1.539c.36 0 .664.123.911.37s.37.55.37.907v10.546c0 .358-.123.66-.37.908-.247.247-.55.37-.907.37H4.727Zm.003-.77H15.27a.49.49 0 0 0 .352-.16.49.49 0 0 0 .16-.352V8.872H4.218v7.218a.49.49 0 0 0 .16.352.49.49 0 0 0 .353.16Zm-.513-8.5h11.565v-2.55a.49.49 0 0 0-.16-.353.49.49 0 0 0-.353-.16H4.73a.49.49 0 0 0-.352.16.49.49 0 0 0-.16.352v2.551Z"
    />
  </Svg>
)
export default CalendarIcon